module.exports = __webpack_public_path__ + "img/ranking-benefits.037a101f.png";